import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/resources/logo-2.png'; // Import your logo image here

const Sidebar = ({ isSidebar, handleSidebar }) => {
    const FORM_ENDPOINT =
        process.env.REACT_APP_FORM_ENDPOINT ||
        "https://formspree.io/f/mrblnpjl"; // TODO: replace with your Formspree ID or backend endpoint

    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState({ submitting: false, success: null, error: null });

    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setStatus({ submitting: true, success: null, error: null });
        try {
            const res = await fetch(FORM_ENDPOINT, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(formData),
            });
            if (!res.ok) {
                const t = await res.text();
                throw new Error(t || `Request failed: ${res.status}`);
            }
            setStatus({ submitting: false, success: "Thanks! We'll get back to you soon.", error: null });
            setFormData({ name: "", email: "", message: "" });
        } catch (err) {
            setStatus({ submitting: false, success: null, error: err.message || "Something went wrong" });
        }
    };
    return (
        <div className={`xs-sidebar-group info-group info-sidebar ${isSidebar ? "isActive" : "close-sidebar"}`}>
            <div className="xs-overlay xs-bg-black" onClick={handleSidebar} />
            <div className="xs-sidebar-widget">
                <div className="sidebar-widget-container">
                    <div className="widget-heading">
                        <span className="close-side-widget" onClick={handleSidebar}>X</span>
                    </div>
                    <div className="sidebar-textwidget">
                        <div className="sidebar-info-contents">
                            <div className="content-inner">
                                <div className="logo">
                                    <Link to="/">
                                        <img src={logo} alt="Logo" />
                                    </Link>
                                </div>
                                <div className="content-box">
                                    <h4>About Us</h4>
                                    <p>Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et magna aliqua. Ut enim ad minim veniam laboris.</p>
                                </div>
                                <div className="form-inner">
                                    <h4>Get a free quote</h4>
                                    <form onSubmit={onSubmit} className="contact-form-validated" noValidate>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Name"
                                                value={formData.name}
                                                onChange={onChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Email"
                                                value={formData.email}
                                                onChange={onChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <textarea
                                                name="message"
                                                placeholder="Message..."
                                                value={formData.message}
                                                onChange={onChange}
                                                rows={4}
                                                required
                                            />
                                        </div>
                                        <div className="form-group message-btn">
                                            <button type="submit" className="thm-btn form-inner__btn" disabled={status.submitting}>
                                                {status.submitting ? "Submitting..." : "Submit Now"}
                                            </button>
                                        </div>
                                        {status.success && (
                                            <p className="text-success" style={{ color: "#2e7d32", marginTop: 8 }}>{status.success}</p>
                                        )}
                                        {status.error && (
                                            <p className="text-error" style={{ color: "#c62828", marginTop: 8 }}>Error: {status.error}</p>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
